import * as React from 'react';
import { Slider as MUISlider, FormControl, FormLabel, } from '@material-ui/core';
import { ErrorMessage } from '../';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import useAppStyles from '../useAppStyles';
import ValueLabelTooltip from './Tooltip';
import Labels from './Labels';
import Dots from './Dots';
import Marker from './Marker';
const useSliderStyles = (props) => makeStyles({
    sliderRoot: {
        position: 'absolute',
        width: 'calc(100% - 16px)',
        zIndex: 10,
        marginTop: -11,
        display: 'flex',
        alignItems: 'center',
        left: '8px',
        '@media (pointer: coarse)': {
            padding: '13px 0',
        },
    },
    label: {
        fontFamily: 'Gotham',
        fontWeight: 400,
        fontSize: 21,
        lineHeight: 1.25,
        margin: '25px 0 0',
        letterSpacing: '-0.56px',
        color: 'var(--secondary)',
        marginBottom: 30,
        textAlign: 'left',
        '@media only screen and (max-width : 800px)': {
            fontSize: 18,
        },
    },
    container: {
        position: 'relative',
        width: '100%',
    },
    track: {
        zIndex: 100,
        background: props.useColor ? 'var(--primary)' : 'none',
        height: '6px',
    },
    thumb: {
        zIndex: 200,
        height: 36,
        width: 36,
        backgroundColor: '#fff',
        border: '6px solid var(--secondary)',
        top: 1,
        right: 0,
        transform: 'translateX(-11px)',
        '&:focus,&:hover': {
            boxShadow: 'inherit',
        },
        '&:after': {
            width: '6px',
            height: '6px',
            backgroundColor: 'var(--gray-mid)',
            borderRadius: '50%',
            top: '9px',
            left: '9px',
        },
        display: props.hideThumb ? 'none' : 'initial',
    },
    mark: {
        zIndex: -1,
        backgroundColor: 'var(--gray-mid)',
        width: '8px',
        height: '20px',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
        cursor: 'pointer',
        marginTop: '13px',
    },
    valueLabel: {
        fontFamily: 'Gotham',
        fontWeight: 700,
        fontSize: '14px',
        minWidth: '30px',
        textTransform: 'uppercase',
        letterSpacing: '-0.56px',
    },
    slider: {
        height: '6px',
        background: props.customSliderBackground ||
            'linear-gradient(to right, var(--gray), var(--secondary))',
        opacity: 'initial',
    },
    sliderDark: {
        height: '6px',
        background: props.customSliderBackground || 'var(--secondary)',
        opacity: 'initial',
    },
    sliderLight: {
        height: '6px',
        background: props.customSliderBackground || 'var(--gray)',
        opacity: 'initial',
    },
});
const Slider = (props) => {
    const { min = 0, max = 100, value, label, onChange, error = false, errorMessage = 'Es necesario mover el slider', labelsPosition = 'before', version = 'gradient', type = typeof value === 'object' ? 'multivalue' : 'one-value', minLabel = min.toString(), maxLabel = max.toString(), middleLabel = '', hideThumb = false, valueLabelDisplay = 'off', } = props;
    const appStyles = useAppStyles();
    const sliderStyles = useSliderStyles({
        hideThumb,
        useColor: type === 'multivalue',
        customSliderBackground: props.customBackgrounds?.slider,
    })();
    return (React.createElement(FormControl, { className: appStyles.formControl, fullWidth: true },
        label ? (React.createElement(FormLabel, { className: appStyles.formLabel }, label)) : null,
        React.createElement(Grid, { container: true, style: {
                marginTop: labelsPosition === 'before' ? '56px' : '35px',
                ...props.style,
            } },
            props.prevValue ? (React.createElement(React.Fragment, null,
                React.createElement(Marker, { color: "var(--secondary)", style: {
                        bottom: labelsPosition === 'before' ? '45px' : '77px',
                        left: `calc(${(props.prevValue / (max - min)) * 100}% - 12px)`,
                    } }),
                React.createElement("div", { style: {
                        position: 'absolute',
                        width: '1px',
                        height: '4px',
                        backgroundColor: 'var(--secondary)',
                        left: `calc(${(props.prevValue / (max - min)) * 100}% - 0.5px)`,
                        bottom: labelsPosition === 'before' ? '35px' : '67px',
                    } }))) : null,
            React.createElement("div", { className: sliderStyles.container, style: {
                    marginBottom: labelsPosition === 'before' ? '0px' : '20px',
                } },
                React.createElement(Dots, Object.assign({}, {
                    max,
                    min,
                    onChange,
                    version,
                    value,
                    leftColor: props.customBackgrounds?.dotLeft,
                    rightColor: props.customBackgrounds?.dotRight,
                })),
                React.createElement(MUISlider, { valueLabelDisplay: 'off', step: 1, min: min, max: max, value: value, marks: props.marks, onClick: props.onClick, onTouchEnd: props.onClick, classes: {
                        root: sliderStyles.sliderRoot,
                        track: sliderStyles.track,
                        rail: version === 'light'
                            ? sliderStyles.sliderLight
                            : version === 'dark'
                                ? sliderStyles.sliderDark
                                : sliderStyles.slider,
                        thumb: sliderStyles.thumb,
                        mark: sliderStyles.mark,
                        valueLabel: sliderStyles.valueLabel,
                    }, onChange: (event, value) => {
                        onChange(value);
                    }, ValueLabelComponent: hideThumb || valueLabelDisplay === 'off'
                        ? undefined
                        : ValueLabelTooltip }),
                React.createElement(Labels, Object.assign({}, {
                    minLabel,
                    middleLabel,
                    maxLabel,
                    labelsPosition,
                    version,
                })),
                React.createElement("div", { style: {
                        marginTop: labelsPosition === 'before' ? '56px' : '',
                    } },
                    React.createElement(ErrorMessage, { condition: error, message: errorMessage }))))));
};
export default Slider;
